import { primaryImageStyles as styles } from "@iewc/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { css } from "styled-components";

styles.badgeAreaWrapper = {
    ...styles.badgeAreaWrapper,
    css: css`
        ${styles.badgeAreaWrapper?.css}
        align-items: center;
        display: flex;
        justify-content: flax-start;
    `,
};

styles.badgeInnerAreaWrapper = {
    css: css`
        display: inline-block;
        position: relative;
    `,
};

styles.badgeImageWrapper = {
    ...styles.badgeImageWrapper,
    css: css`
        ${styles.badgeImageWrapper?.css}
        width: auto;
    `,
};
